import {
  TOOLTIP_BACKGROUND_COLOR_DARK,
  TOOLTIP_BACKGROUND_COLOR_LIGHT,
  TOOLTIP_TEXT_COLOR_LIGHT,
  TOOLTIP_TEXT_COLOR_DARK,
} from './utils/mapColors';

type PlannerMapTooltipProps = {
  values: string[];
  position: { x: number; y: number };
  offset?: number;
  maxWidth?: number;
  theme?: 'light' | 'dark';
};

const PlannerMapTooltip: React.FC<PlannerMapTooltipProps> = ({
  values,
  position,
  offset = 16,
  maxWidth,
  theme = 'light',
}) => {
  const backgroundColor = theme === 'light' ? TOOLTIP_BACKGROUND_COLOR_LIGHT : TOOLTIP_BACKGROUND_COLOR_DARK;
  const textColor = theme === 'light' ? TOOLTIP_TEXT_COLOR_LIGHT : TOOLTIP_TEXT_COLOR_DARK;

  return (
    <div
      className="pointer-events-none absolute z-10"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        transform: `translate(-50%, calc(-100% - ${offset}px))`,
        background: backgroundColor,
        color: textColor,
        padding: '8px',
        borderRadius: '10px',
        fontFamily: 'Inter',
        fontSize: '12px',
        whiteSpace: maxWidth ? 'normal' : 'nowrap',
        maxWidth: maxWidth ? `${maxWidth}px` : undefined,
      }}
    >
      {values.map((value) => (
        <div key={value}>{value}</div>
      ))}
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translate(-50%, calc(100% - 1px))',
          width: 0,
          height: 0,
          borderLeft: '10px solid transparent',
          borderRight: '10px solid transparent',
          borderTop: `10px solid ${backgroundColor}`,
        }}
      />
    </div>
  );
};

export default PlannerMapTooltip;
